module.exports = __webpack_public_path__ + "media/images/common/search/icon-location-b9197e8234466997eca7f1fed6b23ac9.png";